import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-6 md:px-10 pt-24 pb-4">
      <ol className="flex items-center gap-1.5 text-sm">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-home-4-line"></i> 首页
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300 text-xs"></i>
            {item.to ? (
              <Link to={item.to} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}